import { ApplicationConfig } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { provideAnimations } from '@angular/platform-browser/animations';
import { NgxCaptchaModule } from 'ngx-captcha';
import { provideHttpClient,HttpClientJsonpModule,withJsonpSupport } from '@angular/common/http';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideAnimations(), // ✅ aquí activas las animaciones
    NgxCaptchaModule,
    provideHttpClient(withJsonpSupport()),
    HttpClientJsonpModule
  ]


};
